import { ConfigState, EngagementPhase } from "./store/definitions";

import { Provider } from "react-redux";
import { WebchatWidget } from "./components/WebchatWidget";
import { addNotification } from "./store/actions/genericActions";
import { changeEngagementPhase } from "./store/actions/genericActions";
import { createRoot } from "react-dom/client";
import { initConfig } from "./store/actions/initActions";
import { initLogger } from "./logger";
import merge from "lodash.merge";
import { notifications } from "./notifications";
import { sessionDataHandler } from "./sessionDataHandler";
import { store } from "./store/store";

const defaultConfig: ConfigState = {
  serverUrl:
    process.env.NODE_ENV === "development"
      ? "http://localhost:3000"
      : "https://atti-api.attuitive.com",
  instanceId: "dev",
  theme: {
    isLight: true,
  },
  fileAttachment: {
    enabled: true,
    maxFileSize: 16777216, // 16 MB
    acceptedExtensions: [
      "jpg",
      "jpeg",
      "png",
      "amr",
      "mp3",
      "mp4",
      "pdf",
      "txt",
    ],
  },
};

const initWebchat = async (config?: ConfigState) => {
  const rootElement = document.getElementById("atti-webchat-widget-root");
  if (!rootElement) {
    throw new Error("Root element not found");
  }

  const root = createRoot(rootElement);
  root.render(
    <Provider store={store}>
      <WebchatWidget />
    </Provider>
  );

  if (!config?.instanceId) {
    store.dispatch(changeEngagementPhase({ phase: EngagementPhase.Error }));
    store.dispatch(
      addNotification(notifications.missingInstanceIdNotification())
    );
    return;
  }

  const mergedConfig = merge({}, defaultConfig, config);
  sessionDataHandler.setEndpoint(mergedConfig.serverUrl);
  sessionDataHandler.setInstanceId(mergedConfig.instanceId);
  store.dispatch(initConfig(mergedConfig));
  initLogger();

  if (window.Cypress) {
    window.store = store;
  }
};

declare global {
  interface Window {
    Atti: {
      initWebchat: (config?: ConfigState) => void;
    };
    Cypress: Cypress.Cypress;
    store: typeof store;
  }
}

// Expose `initWebchat` function to window object
Object.assign(window, {
  Atti: {
    initWebchat,
  },
});
